export enum HubspotTicketStatusTypes {
    New = 0,
    WaitingOnContact = 1,
    WaitingOnUs = 2,
    Closed = 99,
}

export enum HubspotTicketUrgencyTypes {
    Low = 0,
    Medium = 1,
    High = 2
}

export class HubspotTicketItem {

    TicketID: number;
    HubspotID: number;
    OriginalAdminID: number;
    OriginalAdminName: string;
    AdminID: number;
    AdminName: string;
    OriginalMemberID: string;
    OriginalMemberName: string;
    MemberID: number;
    MemberName: string;
    DueDate: Date;
    DateTimeCreated: Date;
    Status: HubspotTicketStatusTypes;
    Urgency: HubspotTicketUrgencyTypes;
    Subject: string;
    Body: string;

    public static FixDates(item: HubspotTicketItem) {
        if (item.DueDate != null && item.DueDate != undefined)
            item.DueDate = new Date(item.DueDate);

        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }
}

export class HubspotTicketItemArray extends Array<HubspotTicketItem> {

    constructor(...items: HubspotTicketItem[]) {
        super(...items);
        Object.setPrototypeOf(this, HubspotTicketItemArray.prototype);
    }

    public static FixDates(items: HubspotTicketItemArray) {
        items.forEach(x => HubspotTicketItem.FixDates(x));
    }

}
